import { Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import BaseWidgetProvider from './base/BaseWidgetProvider'
import AccessTimeIcon from '@mui/icons-material/AccessTime'

const WidgetClock = (props) => {
  const { data } = props
  const [dateTime, setDateTime] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => {
      setDateTime(new Date())
    }, 1000)
    return () => clearInterval(timer)
  }, [])

  const widthPercentage = props.w / props.columns

  const timeString = dateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: widthPercentage > 0.3 ? '2-digit' : undefined })
  const dateString = dateTime.toLocaleDateString([], { weekday: widthPercentage > 0.4 ? 'long' : undefined, year: 'numeric', month: widthPercentage > 0.3 ? 'long' : '2-digit', day: 'numeric' })

  return (
    <Stack
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2
      }}
    >
      <Typography variant='h3' component='div' sx={{ fontSize: data?.hourFontSize ? data.hourFontSize : undefined }}>
        {timeString}
      </Typography>
      {props.h > 1
        ? (
          <Typography variant='h5' sx={{ fontSize: data?.dateFontSize ? data.dateFontSize : undefined }}>
            {dateString}
          </Typography>
          )
        : null}
    </Stack>
  )
}

class WidgetClockProvider extends BaseWidgetProvider {
  getCode = () => 'WidgetClockProvider'

  getName = () => 'Clock'

  getIcon = () => AccessTimeIcon

  createWidget = (props) => <WidgetClock {...props} />

  getWidgetInfo = (columns, cellHeight) => {
    return { ...super.getWidgetInfo(columns, cellHeight), availableWithoutDevice: true }
  }

  getConfigurationInfo = () => {
    return [
      {
        key: 'hourFontSize',
        type: 'text',
        label: 'Hour font size',
        defaultValue: '4rem'
      },
      {
        key: 'dateFontSize',
        type: 'text',
        label: 'Date font size',
        defaultValue: '2rem'
      }
    ]
  }
}

export default WidgetClockProvider
